/**
 * De alinea's zoals de leerling ze leest.
 *
 * Het model zet soms een kopje als losse alinea (alleen **Kopje**). Die
 * komt bij de alinea erna, zodat er geen alinea van één regel met een eigen
 * nummer en een eigen knop Lees voor staat.
 */

const ALLEEN_KOPJE = /^\s*\*\*[^*]+\*\*\s*$/;

export function voegKoppenSamen(alineas) {
  const uitkomst = [];
  for (let i = 0; i < alineas.length; i++) {
    const alinea = alineas[i];
    if (ALLEEN_KOPJE.test(alinea.inhoud) && i + 1 < alineas.length) {
      const volgende = alineas[i + 1];
      uitkomst.push({ ...volgende, inhoud: alinea.inhoud + ' ' + volgende.inhoud });
      i++;
    } else {
      uitkomst.push(alinea);
    }
  }
  return uitkomst;
}

/** Per alinea het niveau waarop hij nu staat, voor de knop Vereenvoudig. */
export function niveausVan(alineas) {
  const niveaus = {};
  alineas.forEach(a => { if (a.current_niveau) niveaus[a.id] = a.current_niveau; });
  return niveaus;
}
